import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  header: {
    marginBottom: theme.spacing(0.5),
  },
  description: {
    color: theme.palette.present.greyBackground,
    "& .MuiTypography-root": {
      lineHeight: theme.spacing(2.25),
    },
  },
  iconPadding: {
    paddingLeft: theme.spacing(4),
  },
  link: {
    color: theme.palette.events.bluePrimary,
    textDecoration: "none",
  },
  component: {
    padding: theme.spacing(2),
  },
  withDivider: {
    borderTop: `1px solid ${theme.palette.gray.muted1}`,
  },
  testName: {
    fontWeight: 600,
  },
}));
